import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FormIngresoService } from 'src/app/services/forms/form-ingreso.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dialog-lista-equipos',
  templateUrl: './dialog-lista-equipos.component.html',
  styleUrls: ['./dialog-lista-equipos.component.css']
})
export class DialogListaEquiposComponent implements OnInit {

  equipoForm!:FormGroup;
  estado:any;
  equipoId:any;

  constructor(private router: Router, private fb: FormBuilder, private almacenService:AventuraService ,private formService: FormIngresoService ,
              public dialogRef: MatDialogRef<DialogListaEquiposComponent>, @Inject(MAT_DIALOG_DATA) public data:any,
             ) {

  }

  ngOnInit(): void {
    this.equipoForm = this.fb.group({
      equipo: this.formService.getEquipoForm()
    });
    console.log(this.data)

    this.equipoForm.get(['equipo','codigo'])?.setValue(this.data.codigo);
    this.equipoForm.get(['equipo','nombre'])?.setValue(this.data.nombre);
    this.equipoForm.get(['equipo','marca'])?.setValue(this.data.marca);
    this.equipoForm.get(['equipo','modelo'])?.setValue(this.data.modelo);
    this.equipoForm.get(['equipo','talla'])?.setValue(this.data.talla);
    this.equipoForm.get(['equipo','categoria'])?.setValue(this.data.categoria);

    this.estado=this.data.estado;
    this.equipoId=this.data.id;
    console.log(this.estado);

  }

  createEquipo(){
    const equipo={
      codigo:this.equipoForm.value.equipo.codigo,
      nombre:this.equipoForm.value.equipo.nombre,
      marca:this.equipoForm.value.equipo.marca,
      modelo:this.equipoForm.value.equipo.modelo,
      talla:this.equipoForm.value.equipo.talla,
      categoria:this.equipoForm.value.equipo.categoria,
      
    };
    console.log(this.equipoForm);
    console.log("equipo")
    console.log(equipo)
    this.almacenService.createEquipo(equipo).subscribe(data=>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Se agregó el equipo al almacén',
        showConfirmButton: false,
        timer: 4000
      });
      console.log("newEquipo");
      console.log(data)
      this.dialogRef.close(1);
    })
  }

  updateEquipo(){
    const equipo={
      codigo:this.equipoForm.value.equipo.codigo,
      nombre:this.equipoForm.value.equipo.nombre,
      marca:this.equipoForm.value.equipo.marca,
      modelo:this.equipoForm.value.equipo.modelo,
      talla:this.equipoForm.value.equipo.talla,
      categoria:this.equipoForm.value.equipo.categoria,
      
    };

    this.almacenService.updateEquipo(this.equipoId,equipo).subscribe(data=>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Se modificó el equipo',
        showConfirmButton: false,
        timer: 4000
      });
      console.log("updatedEquipoDone");
      console.log(data)
      this.dialogRef.close(1);
    })
  }

}
